import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppButton from './components/WhatsAppButton';

// Lazy load all pages for better performance
const Homepage = lazy(() => import('./pages/Homepage'));
const Destinations = lazy(() => import('./pages/Destinations'));
const EverestRegion = lazy(() => import('./pages/regions/EverestRegion'));
const AnnapurnaRegion = lazy(() => import('./pages/regions/AnnapurnaRegion'));
const LangtangRegion = lazy(() => import('./pages/regions/LangtangRegion'));
const ManasluRegion = lazy(() => import('./pages/regions/ManasluRegion'));
const UpperMustangRegion = lazy(() => import('./pages/regions/UpperMustangRegion'));
const KangchenungaRegion = lazy(() => import('./pages/regions/KangchenungaRegion'));
const RolwalingRegion = lazy(() => import('./pages/regions/RolwalingRegion'));
const DolpaRegion = lazy(() => import('./pages/regions/DolpaRegion'));
const MakaluRegion = lazy(() => import('./pages/regions/MakaluRegion'));
const NewDestinationsRegion = lazy(() => import('./pages/regions/NewDestinationsRegion'));
const TrekDetail = lazy(() => import('./pages/TrekDetail'));
const HeliTours = lazy(() => import('./pages/HeliTours'));
const HeliTourDetail = lazy(() => import('./pages/HeliTourDetail'));
const About = lazy(() => import('./pages/About'));
const Booking = lazy(() => import('./pages/Booking'));
const Contact = lazy(() => import('./pages/Contact'));
const Services = lazy(() => import('./pages/Services'));
const Blog = lazy(() => import('./pages/Blog'));
const BlogDetail = lazy(() => import('./pages/BlogDetail'));
const Privacy = lazy(() => import('./pages/Privacy'));
const Terms = lazy(() => import('./pages/Terms'));
const FAQ = lazy(() => import('./pages/FAQ'));

// Ultra-fast loading fallback
const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-slate-900 to-slate-800">
    <div className="w-16 h-16 border-4 border-orange-500/30 border-t-orange-500 rounded-full animate-spin"></div>
  </div>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <WhatsAppButton />
      <div className="flex min-h-screen flex-col">
        <Navbar />
        <main className="flex-1">
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="/destinations" element={<Destinations />} />
              <Route path="/destinations/everest" element={<EverestRegion />} />
              <Route path="/destinations/annapurna" element={<AnnapurnaRegion />} />
              <Route path="/destinations/langtang" element={<LangtangRegion />} />
              <Route path="/destinations/manaslu" element={<ManasluRegion />} />
              <Route path="/destinations/upper-mustang" element={<UpperMustangRegion />} />
              <Route path="/destinations/kangchenjunga" element={<KangchenungaRegion />} />
              <Route path="/destinations/rolwaling" element={<RolwalingRegion />} />
              <Route path="/destinations/dolpa" element={<DolpaRegion />} />
              <Route path="/destinations/makalu" element={<MakaluRegion />} />
              <Route path="/destinations/new-destinations" element={<NewDestinationsRegion />} />
              <Route path="/trek/:slug" element={<TrekDetail />} />
              <Route path="/heli-tours" element={<HeliTours />} />
              <Route path="/heli-tours/:slug" element={<HeliTourDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/services" element={<Services />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogDetail />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/faq" element={<FAQ />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;